import { createContext/*, useContext */, useEffect, useMemo, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";

import DataGrid, { Column /*, useFocusRef, HeaderRendererProps */, SortColumn } from 'react-data-grid'
import { getComparator, filterColumnClassName, filterCellClass/*, SummaryRow */ } from '../../datagrid/extra'

import EmptyRowsRenderer from '../../components/EmptyRow'
import FilterRowsRenderer from '../../components/Filter'
import ManualSync from "../../components/ManualSync";
import LoadingRowsRenderer from '../../components/Loading'
import { syncProduct } from "../../graphql/mutations";
import { GiFireBottle } from "react-icons/gi";
import { productByPackaging } from "../../graphql/queries";
import { productPackaging } from "../../constants/enum";
import { ProductLibProduct } from "../../API";

import { format } from "date-fns";
// import Icon from "../../components/Icon";
import ButtonPillBrand from "../../components/ButtonPillBrand";

const FilterContext = createContext<Filter | undefined>(undefined);

interface Filter extends Omit<ProductLibProduct, 'id'> {
  id: string;
  enabled: boolean;
}

const limit_row_on_page = 1000;

function SyncProduct() {

  const statusAll = 'All';
  const [ tabName, setTabName ] = useState<string>('byEA');
  const [ isLoading, setIsLoading ] = useState(false);
  // const [ nextToken, setNextToken ] = useState<string>();
  const [ rows, setRows ] = useState<any>([]);

  const [ sortColumns ] = useState<readonly SortColumn[]>([{columnKey: 'updatedAt', direction: 'DESC'}]);

  const [filters, setFilters] = useState<Filter>({
    __typename: 'ProductLibProduct',
    id: '',
    brand: '',
    brandType: '',
    materialCode: '',
    materialName: '',
    barcode: '',
    productHierachy: '',
    name: '',
    titleEN: '',
    titleTH: '',
    category: '',
    subcategory: '',
    collection: '',
    color: '',
    classifier: '',
    packaging: '',
    status: '',
    length: 0,
    width: 0,
    height: 0,
    weight: 0,
    weightUnit: '',
    // description: '',
    descriptionEN: '',
    descriptionTH: '',
    createdAt: '',
    updatedAt: '',
    enabled: false
  });


  const dateFormat = 'dd-MM-yyyy (HH:mm:ss)';
  const filteredRows = useMemo(() => {
    return rows.filter((r: any) => {
      return (
        (filters.id ? r.id ? r.id.toLocaleLowerCase().includes(filters.id.toLowerCase()) : false : true) &&
        (filters.brand ? r.brand ? r.brand.toLocaleLowerCase().includes(filters.brand.toLowerCase()) : false : true) &&
        (filters.brandType ? r.brandType ? r.brandType.toLocaleLowerCase().includes(filters.brandType.toLowerCase()) : false : true) &&
        (filters.materialCode ? r.materialCode ? r.materialCode.toLocaleLowerCase().includes(filters.materialCode.toLowerCase()) : false : true) &&
        (filters.materialName ? r.materialName ? r.materialName.toLocaleLowerCase().includes(filters.materialName.toLowerCase()) : false : true) &&
        (filters.barcode ? r.barcode ? r.barcode.toLocaleLowerCase().includes(filters.barcode.toLowerCase()) : false : true) &&
        (filters.productHierachy ? r.productHierachy ? r.productHierachy.toLocaleLowerCase().includes(filters.productHierachy.toLowerCase()) : false : true) &&
        (filters.name ? r.name ? r.name.toLocaleLowerCase().includes(filters.name.toLowerCase()) : false : true) &&
        (filters.titleEN ? r.titleEN ? r.titleEN.toLocaleLowerCase().includes(filters.titleEN.toLowerCase()) : false : true) &&
        (filters.titleTH ? r.titleTH ? r.titleTH.toLocaleLowerCase().includes(filters.titleTH.toLowerCase()) : false : true) &&
        (filters.category ? r.category ? r.category.toLocaleLowerCase().includes(filters.category.toLowerCase()) : false : true) &&
        (filters.subcategory ? r.subcategory ? r.subcategory.toLocaleLowerCase().includes(filters.subcategory.toLowerCase()) : false : true) &&
        (filters.collection ? r.collection ? r.collection.toLocaleLowerCase().includes(filters.collection.toLowerCase()) : false : true) &&
        (filters.color ? r.color ? r.color.toLocaleLowerCase().includes(filters.color.toLowerCase()) : false : true) &&
        (filters.classifier ? r.classifier ? r.classifier.toLocaleLowerCase().includes(filters.classifier.toLowerCase()) : false : true) &&
        (filters.packaging ? r.packaging ? r.packaging.toLocaleLowerCase().includes(filters.packaging.toLowerCase()) : false : true) &&
        (filters.status !== statusAll ? r.status ? r.status.toLocaleLowerCase().includes(filters.status!.toLowerCase()) : false : true) &&
        (filters.length ? r.length ? r.length.toLocaleLowerCase().includes(filters.length) : false : true) &&
        (filters.width ? r.width ? r.width.toLocaleLowerCase().includes(filters.width) : false : true) &&
        (filters.height ? r.height ? r.height.toLocaleLowerCase().includes(filters.height) : false : true) &&
        (filters.weight ? r.weight ? r.weight.toLocaleLowerCase().includes(filters.weight) : false : true) &&
        (filters.weightUnit ? r.weightUnit ? r.weightUnit.toLocaleLowerCase().includes(filters.weightUnit.toLowerCase()) : false : true) &&
        // (filters.description ? r.description ? r.description.toLocaleLowerCase().includes(filters.description.toLowerCase()) : false : true) &&
        (filters.descriptionEN ? r.descriptionEN ? r.descriptionEN.toLocaleLowerCase().includes(filters.descriptionEN.toLowerCase()) : false : true) &&
        (filters.descriptionTH ? r.descriptionTH ? r.descriptionTH.toLocaleLowerCase().includes(filters.descriptionTH.toLowerCase()) : false : true) &&
        (filters.createdAt ? r.createdAt ? format(new Date(r.createdAt), dateFormat).toLocaleLowerCase().includes(filters.createdAt.toLowerCase()) : false : true) &&
        (filters.updatedAt ? r.updatedAt ? format(new Date(r.updatedAt), dateFormat).toLocaleLowerCase().includes(filters.updatedAt.toLowerCase()) : false : true)
      );
    });
  }, [rows, filters]);

  function clearFilters() {
    setFilters({
      __typename: 'ProductLibProduct',
      id: '',
      brand: '',
      brandType: '',
      materialCode: '',
      materialName: '',
      barcode: '',
      productHierachy: '',
      name: '',
      titleEN: '',
      titleTH: '',
      category: '',
      subcategory: '',
      collection: '',
      color: '',
      classifier: '',
      packaging: '',
      status: '',
      length: 0,
      width: 0,
      height: 0,
      weight: 0,
      weightUnit: '',
      // description: '',
      descriptionEN: '',
      descriptionTH: '',
      createdAt: '',
      updatedAt: '',
      enabled: false
    });
  }

  function toggleFilters() {
    setFilters((filters) => ({
      ...filters,
      enabled: !filters.enabled
    }));
  }

  const sortedRows = useMemo((): readonly ProductLibProduct[] => {
    if (sortColumns.length === 0) return filteredRows;

    return [...filteredRows].sort((a, b) => {
      for (const sort of sortColumns) {
        const comparator = getComparator(sort.columnKey);
        const compResult = comparator(a, b);
        if (compResult !== 0) {
          return sort.direction === "ASC" ? compResult : -compResult;
        }
      }
      return 0;
    });
  }, [filteredRows, sortColumns]);

  // const summaryRows = useMemo(() => {
  //   const summaryRow: SummaryRow = {
  //     id: "total_0",
  //     totalCount: sortedRows.length,
  //   };
  //   return [summaryRow];
  // }, [sortedRows]);

  const fetchMasterProductData = async (tabName: string) => {
    console.log("tabName : ", tabName)
    switch(tabName) {
      case 'byEA':
        const productsByEA: any = await API.graphql(graphqlOperation(productByPackaging, { limit: limit_row_on_page, packaging: productPackaging.EA }));
        const productItemsByEA = productsByEA.data.productByPackaging.items;
        setRows(productItemsByEA);
        console.log("productsByEA.data.productByPackaging : ", productsByEA.data.productByPackaging)
        // setNextToken(advancesByWithdrawer.data.advanceByWithdrawer.nextToken);
        setIsLoading(false);
        break;
      case 'byPac':
        const productsByPac: any = await API.graphql(graphqlOperation(productByPackaging, { limit: limit_row_on_page, packaging: productPackaging.PAC }));
        const productItemsByPac = productsByPac.data.productByPackaging.items;
        setRows(productItemsByPac);
        // setNextToken(advancesByWithdrawer.data.advanceByWithdrawer.nextToken);
        setIsLoading(false);
        break;
      case 'byCase':
        const productsByCase: any = await API.graphql(graphqlOperation(productByPackaging, { limit: limit_row_on_page, packaging: productPackaging.CASE }));
        const productItemsByCase = productsByCase.data.productByPackaging.items;
        setRows(productItemsByCase);
        // setNextToken(advancesByWithdrawer.data.advanceByWithdrawer.nextToken);
        setIsLoading(false);
        break;
      default:
        setRows([]);
        // setNextToken('');
        setIsLoading(false);
    }
  };

  // function FilterRenderer<R, SR, T extends HTMLOrSVGElement>({
  //   isCellSelected,
  //   onSort,
  //   sortDirection,
  //   column,
  //   children,
  // }: HeaderRendererProps<R, SR> & {
  //   children: (args: {
  //     ref: React.RefObject<T>;
  //     tabIndex: number;
  //     filters: Filter;
  //   }) => React.ReactElement;
  // }) {
  //   const filters = useContext(FilterContext)!;
  //   const { ref, tabIndex } = useFocusRef<T>(isCellSelected);
  //   return (
  //     <>
  //       <div
  //         className="flex flex-row"
  //         onClick={() => {
  //           onSort(false);
  //         }}
  //       >
  //         <div className="flex flex-row mt-1 ml-2 mr-auto text-truncate">
  //           <span>{column.name}</span>
  //         </div>
  //         <div className="mt-5">
  //           {sortDirection === "ASC" && <Icon name="sort-alpha-down" />}
  //           {sortDirection === "DESC" && <Icon name="sort-alpha-up" />}
  //           {sortDirection !== "DESC" && sortDirection !== "ASC" && (
  //             <Icon name="arrows-alt-v" />
  //           )}
  //         </div>
  //       </div>
  //       {filters.enabled && <div className=''>{children({ ref, tabIndex, filters })}</div>}
  //     </>
  //   );
  // }

  const SyncMasterProductColumn: Column<ProductLibProduct>[] = [
    { 
      key: 'brand',
      name: 'brand',
      sortable: true,
      headerCellClass: filterColumnClassName,
      cellClass: filterCellClass,
      formatter: ({ row }) => (
        <ButtonPillBrand brand={row.brand}/>
      )
    },
    { key: 'brandType', name: 'brandType' },
    { key: 'materialCode', name: 'materialCode' },
    { key: 'materialName', name: 'materialName' },
    { key: 'barcode', name: 'barcode' },
    { key: 'productHierachy', name: 'productHierachy', width: 140 },
    { key: 'titleEN', name: 'titleEN', resizable: true },
    { key: 'titleTH', name: 'titleTH' },
    { key: 'status', name: 'status' },
    { key: 'length', name: 'length' },
    { key: 'width', name: 'width' },
    { key: 'height', name: 'height' },
    { key: 'weight', name: 'weight' },
    { key: 'weightUnit', name: 'weightUnit' },
  ]

  useEffect(() => {
    setIsLoading(true);
    fetchMasterProductData(tabName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[tabName]);

  async function triggerSyncFn(){
    setIsLoading(true);
    setRows([]);

    let response = await API.graphql(
      graphqlOperation(syncProduct, { type: "xxx" })
    );

    if (response) {
      fetchMasterProductData(tabName);
      setIsLoading(false)
      console.log("res : ", response)
    } else {
      console.log("error : ", response)
    }
  }

  return (
    <>
      <div className="px-6 py-1">
        <div className="page-container-title">
          <span className="flex items-center">
            <h3 className="font-bold mr-2">
              Product Master
            </h3>
            <GiFireBottle size={24} color="rgb(244 63 94)"/>
          </span>
          <ManualSync toggleSync={triggerSyncFn}/>
        </div>
        <ul
          className="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 my-2"
          role="tablist"
          data-te-nav-ref>
          <li role="presentation">
            <a
              href="#tabs-byEA"
              className="my-2 block border-x-0 border-t-0 border-b-2 border-transparent px-7 pt-4 pb-3.5 text-xs font-medium uppercase leading-tight text-neutral-500 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate focus:border-transparent data-[te-nav-active]:border-emerald data-[te-nav-active]:text-emerald dark:text-neutral-400 dark:hover:bg-transparent data-[te-nav-active]:border-emerald-400 data-[te-nav-active]:text-emerald-400"
              data-te-toggle="pill"
              data-te-target="#tabs-byEA"
              data-te-nav-active
              role="tab"
              aria-controls="tabs-byEA"
              aria-selected="true"
              onClick={()=>{setTabName('byEA')}}
              >
                <div className='flex items-center gap-2'>
                  <span className=''>By EA</span>
                </div>
            </a>
          </li>
          <li role="presentation">
            <a
              href="#tabs-byPac"
              className="focus:border-transparen my-2 block border-x-0 border-t-0 border-b-2 border-transparent px-7 pt-4 pb-3.5 text-xs font-medium uppercase leading-tight text-neutral-500 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate data-[te-nav-active]:border-primary data-[te-nav-active]:text-primary dark:text-neutral-400 dark:hover:bg-transparent dark:data-[te-nav-active]:border-primary-400 dark:data-[te-nav-active]:text-primary-400"
              data-te-toggle="pill"
              data-te-target="#tabs-byPac"
              role="tab"
              aria-controls="tabs-byPac"
              aria-selected="false"
              onClick={()=>{setTabName('byPac')}}
              >
                <div className='flex items-center gap-2'>
                  <span className=''>By Pac</span>
                </div>
            </a>
          </li>
          <li role="presentation">
            <a
              href="#tabs-byCase"
              className="focus:border-transparen my-2 block border-x-0 border-t-0 border-b-2 border-transparent px-7 pt-4 pb-3.5 text-xs font-medium uppercase leading-tight text-neutral-500 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate data-[te-nav-active]:border-orange-400 data-[te-nav-active]:text-orange-400 dark:text-neutral-400 dark:hover:bg-transparent dark:data-[te-nav-active]:border-orange-400 dark:data-[te-nav-active]:text-orange-400"
              data-te-toggle="pill"
              data-te-target="#tabs-byCase"
              role="tab"
              aria-controls="tabs-byCase"
              aria-selected="false"
              onClick={()=>{setTabName('byCase')}}
              >
                <div className='flex items-center gap-2'>
                  <span className=''>By Case</span>
                </div>
            </a>
          </li>
        </ul>

        <div className="mb-6">
          <div
            className="hidden opacity-0 opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
            id="tabs-byEA"
            role="tabpanel"
            aria-labelledby="tabs-byEA-tab"
            data-te-tab-active
          >
            <div className="flex flex-wrap items-center justify-between mb-4">
              <FilterRowsRenderer
                toggleFilters={toggleFilters}
                clearFilters={clearFilters}
                activeFilters={filters}
              />
            </div>
            <FilterContext.Provider value={filters}>
              <DataGrid
                columns={SyncMasterProductColumn}
                rows={sortedRows}
                renderers={{ noRowsFallback: <EmptyRowsRenderer/> }}
                style={{ height: '60vh' }}
              />
              <div className='loading-renderer'>
                {isLoading && <LoadingRowsRenderer/>}
              </div>
            </FilterContext.Provider>
          </div>
          <div
            className="hidden opacity-0 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
            id="tabs-byPac"
            role="tabpanel"
            aria-labelledby="tabs-byPac-tab"
          >
            <div className="flex flex-wrap items-center justify-between mb-4">
              <FilterRowsRenderer
                toggleFilters={toggleFilters}
                clearFilters={clearFilters}
                activeFilters={filters}
              />
            </div>
            <FilterContext.Provider value={filters}>
              <DataGrid
                columns={SyncMasterProductColumn}
                rows={sortedRows}
                renderers={{ noRowsFallback: <EmptyRowsRenderer/> }}
                style={{ height: '60vh' }}
              />
              <div className='loading-renderer'>
                {isLoading && <LoadingRowsRenderer/>}
              </div>
            </FilterContext.Provider>
          </div>
          <div
            className="hidden opacity-0 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
            id="tabs-byCase"
            role="tabpanel"
            aria-labelledby="tabs-byCase-tab"
            data-te-tab-active
          >
            <div className="flex flex-wrap items-center justify-between mb-4">
              <FilterRowsRenderer
                toggleFilters={toggleFilters}
                clearFilters={clearFilters}
                activeFilters={filters}
              />
            </div>
            <FilterContext.Provider value={filters}>
              <DataGrid
                columns={SyncMasterProductColumn}
                rows={sortedRows}
                renderers={{ noRowsFallback: <EmptyRowsRenderer/> }}
                style={{ height: '60vh' }}
              />
              <div className='loading-renderer'>
                {isLoading && <LoadingRowsRenderer/>}
              </div>
            </FilterContext.Provider>
          </div>
        </div>
      </div>
    </>
  );
}

export default SyncProduct;
